export const vipsImages = [
	'https://vgedonehubappsstaweupro.storage.vged.es/storage/images-portal/modulo-ugc/1.png',
	'https://vgedonehubappsstaweupro.storage.vged.es/storage/images-portal/modulo-ugc/2.png',
	'https://vgedonehubappsstaweupro.storage.vged.es/storage/images-portal/modulo-ugc/3.png',
	'https://vgedonehubappsstaweupro.storage.vged.es/storage/images-portal/modulo-ugc/4.png',
	'https://vgedonehubappsstaweupro.storage.vged.es/storage/images-portal/modulo-ugc/5.png',
	'https://vgedonehubappsstaweupro.storage.vged.es/storage/images-portal/modulo-ugc/6.png',
	'https://vgedonehubappsstaweupro.storage.vged.es/storage/images-portal/modulo-ugc/7.png',
	'https://vgedonehubappsstaweupro.storage.vged.es/storage/images-portal/modulo-ugc/8.png',
	'https://vgedonehubappsstaweupro.storage.vged.es/storage/images-portal/modulo-ugc/9.png',
	'https://vgedonehubappsstaweupro.storage.vged.es/storage/images-portal/modulo-ugc/10.png',
	'https://vgedonehubappsstaweupro.storage.vged.es/storage/images-portal/modulo-ugc/11.png',
	'https://vgedonehubappsstaweupro.storage.vged.es/storage/images-portal/modulo-ugc/12.png',
];
